export default "__VITE_ASSET__Cc5nvO0L__"